"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = showModal;
var _types = require("../types");
/**
 * Show a modal
 *
 * @param {*} type
 * @param {*} initialValue
 */
function showModal(type) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return function (dispatch) {
    var action = {
      type: _types.SHOW_MODAL,
      payload: {
        type: type,
        initialValue: initialValue
      }
    };
    dispatch(action);
  };
}